import {Component, OnInit, Input} from "@angular/core";
import {UserService} from "../../services/user.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-login-widget',
  templateUrl: './login-widget.component.html',
  styleUrls:['./login-widget.component.scss']
})
export class LoginWidgetComponent implements OnInit {

  user: any = {};

  @Input() private profileUrl: string = "/";

  constructor(private userService: UserService,
              private router: Router) {
  }

  ngOnInit() {
    this.userService.getCurrentUser()
      .then(user => {
        this.user = user;
      })
  }

  logout() {
    this.userService.logout();
  }

  gotoManageAccount() {
    this.router.navigateByUrl(this.profileUrl);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/login-widget/login-widget.component.ts